import { render, staticRenderFns } from "./PanelBoxesContainer.vue?vue&type=template&id=29cbec2a&scoped=true"
import script from "./PanelBoxesContainer.vue?vue&type=script&lang=js"
export * from "./PanelBoxesContainer.vue?vue&type=script&lang=js"
import style0 from "./PanelBoxesContainer.vue?vue&type=style&index=0&id=29cbec2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cbec2a",
  null
  
)

export default component.exports